import $ from 'jquery';
import jQuery from 'jquery';
import 'bootstrap';
import Rellax from 'rellax';
import validate from 'jquery-validation';
import animatedScrollTo from 'animated-scroll-to';
import cycle from 'jquery-cycle-2';
import "babel-polyfill";
import 'slick-carousel';
// import 'jquery-zoom';
import SimpleLightbox from "simple-lightbox";

SimpleLightbox.registerAsJqueryPlugin($);

require('./tracking');
require('./customSelect');

let tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

$(document).ready(function () {
    $.validator.addMethod('emailValid', function (email, element) {
        // add Class emailValid to email fields
        return (
            this.optional(element) ||
            /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(email)
        );
    }, 'Please specify a valid email');

    $('.js-validate-form').each(function (index, element) {
        var _form = $(element);

        _form.validate({
            ignore: '',
            focusInvalid: false,
            errorContainer: element.querySelector('.js-error-container'),
            errorLabelContainer: element.querySelector('.js-error-container'),
            wrapper: 'div',
            errorPlacement: function (error, elem) {
                let target = elem;

                if (elem.parent().hasClass('input-checkbox')) {
                    target = elem.parent();
                }

                error.insertAfter(target);
            },
        });
    });

    if ($('.button--video_play').length > 0) {
        $('.button--video_play').simpleLightbox();
    }

    if ($('.button--image_show').length > 0) {
        $('.button--image_show').simpleLightbox();
    }

    if ($('#Page-Flash--message').length > 0) {
        setTimeout(function () {
            $('#Page-Flash--message').fadeOut();
        }, 5000);
    }

    $('#Page-Flash--message').on('click', '.close', function () {
        $('#Page-Flash--message').fadeOut();
    });

    $('.profile .front .flippy').on('mouseover', function (e) {
        e.preventDefault();
        $(this).parents('.profile').toggleClass('active');
    })

    $('.profile .profile-toggle').on('mouseout', function (e) {
        e.preventDefault();
        $(this).parents('.profile').removeClass('active');
    });


    $(window).scroll(function () {
        stickyMenu();
    });

    stickyMenu();

    function stickyMenu() {
        var scroll = $(window).scrollTop();
        if (scroll >= 35) {
            $("header").addClass("sticky");
        } else {
            $("header").removeClass("sticky");
        }
    }

    $('select[name=mobileCocktailFilter]').on('change', function() {
        var url = $(this).val();
        if (url) {
            window.location = url;
        }
        return false;
    });

    // Toggle 'Show / Hide locations...' text
    $('.bar .locations')
        .on('hide.bs.collapse', function (ev) {
            $(`[data-target="#${ev.target.id}"] span`).text('Show');
        })
        .on('show.bs.collapse', function (ev) {
            $(`[data-target="#${ev.target.id}"] span`).text('Hide');
        });

    function video (videoBlockId) {
        const self = this;

        self.videoBlockEl = document.querySelector(videoBlockId);
        self.playOverlay = self.videoBlockEl.querySelector('.video-player-overlay');
        self.playButton = self.playOverlay.querySelector('.yt-player-trigger-play');
        self.iframeId = self.videoBlockEl.querySelector('iframe').getAttribute('id');
        self.player = null;

        self.setPlayer = function (player) {
            self.player = player;
        }

        self.onPlayerReady = function () {
            if (self.playButton) {
                self.playButton.addEventListener('click', self.handlePlayButtonClick.bind(self), true);
            }
        }

        self.handlePlayButtonClick = function (event) {
            event.preventDefault();
            event.stopPropagation();

            self.playOverlay.classList.add('hidden');
            self.player.playVideo();
        }
    }

    function videos () {
        const self = this;

        self.players = [];
        self.queue = [];

        self.add = function (video) {
            self.queue.push(video);
        }

        self.load = function () {
            window.onYouTubePlayerAPIReady = function() {
                self.queue.forEach(video => {
                    const player = new YT.Player(video.iframeId, {
                        events: {
                            'onReady': video.onPlayerReady.bind(video)
                        }
                    });
                    video.setPlayer(player);
                })
            }.bind(self);
        }
    }

    const videoBlocks = document.querySelectorAll('.video-clip');
    const videosOBJ = new videos();

    for (const videoBlock of videoBlocks) {
        const targetVideoId = '#' + videoBlock.getAttribute('id');
        const targetVideoObj = new video(targetVideoId);
        videosOBJ.add(targetVideoObj);
    }

    videosOBJ.load();

    const expertReviewCount = $('.expert-reviews-slick').data('review-count');
    let expertSlidesPerDisplay = 1;
    if (expertReviewCount && expertReviewCount >= 2) {
        expertSlidesPerDisplay = 2;
    }

    $('.expert-reviews-slick').slick({
        slidesToShow: expertSlidesPerDisplay,
        slidesToScroll: expertSlidesPerDisplay,
        dots: false,
        arrows: true,
        autoplay: false,
        swipe: false,
        draggable: false,
        swipeToSlide: false,
        touchMove: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipe: true,
                    draggable: true,
                    swipeToSlide: true,
                    touchMove: true,
                }
            }
        ]
    });

    const fanReviewCount = $('.fan-reviews-slick').data('review-count');
    let fanSlidesPerDisplay = 1;
    if (fanReviewCount && fanReviewCount >= 2) {
        fanSlidesPerDisplay = 2;
    }

    $('.fan-reviews-slick').slick({
        slidesToShow: fanSlidesPerDisplay,
        slidesToScroll: fanSlidesPerDisplay,
        dots: false,
        arrows: true,
        autoplay: false,
        swipe: false,
        draggable: false,
        swipeToSlide: false,
        touchMove: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipe: true,
                    draggable: true,
                    swipeToSlide: true,
                    touchMove: true,
                }
            }
        ]
    });

    $('.display-slick').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        swipe: false,
        draggable: false,
        swipeToSlide: false,
        touchMove: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    swipe: true,
                    draggable: true,
                    swipeToSlide: true,
                    touchMove: true,
                    infinite: true,
                }
            }
        ]
    });

    $('.thumbs-slick').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: false,
    });

    $('.thumb-controller').each(function() {

        $(this).on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            let slickIndex = $(this).closest('.slick-slide').attr('data-slick-index');
            $('.display-slick')[0].slick.slickGoTo(parseInt(slickIndex), true);
        });
    })

    $('.gallery-carousel').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: true,
    });

    $('.home-2023-item-carousel').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 375,
                settings: {
                    centerMode: true,
                    centerPadding: '40px',
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    centerMode: true,
                    centerPadding: '60px',
                },
            }
        ],
    });

    const updateArticleSlickArrowText = (e, slick, i) => {
        if (! i) i = slick.currentSlide;

        const nextIndex = (i + 1) <= (slick.$slides.length - 1) ? (i + 1) : 0;
        const previousIndex = (i - 1) >= 0 ? (i - 1) : (slick.$slides.length - 1);
        const next = slick.$slides[nextIndex];
        const previous = slick.$slides[previousIndex];
        if (! (previous && next)) return;
        // if (previous === next) return;

        const nextHtml = next.querySelector('.js-slide');
        const previousHtml = previous.querySelector('.js-slide');
        if (! (previousHtml && nextHtml)) return;

        const nextArrow = slick.$nextArrow.first();
        nextArrow.find('.name').first().text(nextHtml.dataset.name);
        nextArrow.find('.title').first().text(nextHtml.dataset.title);

        const prevArrow = slick.$prevArrow.first();
        prevArrow.find('.name').first().text(previousHtml.dataset.name);
        prevArrow.find('.title').first().text(previousHtml.dataset.title);
    };

    $('.article-video-slides-slick').on('init', updateArticleSlickArrowText);

    $('.article-video-slides-slick').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplay: false,
        swipe: true,
        draggable: true,
        swipeToSlide: true,
        touchMove: true,
        infinite: true,
        adaptiveHeight: true,
        prevArrow:'<button type="button" class="slick-prev slick-arrow"><span class="name"></span><span class="title"></span></button>',
        nextArrow:'<button type="button" class="slick-next slick-arrow"><span class="name"></span><span class="title"></span></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    adaptiveHeight: false,
                }
            }
        ]
    });

    $('.article-video-slides-slick').on('afterChange', updateArticleSlickArrowText);

    // if ($(window).width() >= 768) {
    //     $('.zoom').each(function() {
    //         window.$(this).zoom({ on:'click' });
    //     });
    // }

    // $(window).on('resize', function() {
    //     // var vh = window.innerHeight * 0.01;
    //     // document.documentElement.style.setProperty('--vh', vh + 'px');

    //     if ($(window).width() < 768 && $('.zoomImg').length) {
    //         $('.zoom').each(function() {
    //             window.$(this).trigger('zoom.destroy');
    //         });
    //     } else if ($(window).width() >= 768 && !$('.zoomImg').length) {
    //         $('.zoom').each(function() {
    //             window.$(this).zoom({ on:'click' });
    //         });
    //     }
    // });

    /**
     * Slide down the big desktop menu
     */
    $('.has-children').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('.fa-toggle').toggleClass('fa-angle-up fa-angle-down');

        if ($(".submenu").is(':hidden')){
            $(".submenu").slideDown(300);
        } else{
            $(".submenu").slideUp(300);
        }
    });

});
